import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import Button from 'components/Shared/Common/Button';
import Drawer from 'components/Shared/Drawers';
import { Field, Form as FinalForm } from "react-final-form";
import { Form } from "antd";
import { LabelUserMultiSelect } from 'components/Shared/Forms';
import { ButtonActions } from 'components/Shared/styles';
import CategoryTitle from 'components/Shared/Layout/CategoryTitle';
import Icon from 'components/Shared/Common/Icon';

const formatMessages = intl => ({
    invitMembers: intl.formatMessage({
        id: 'drawer.addContacts.title',
        defaultMessage: 'Inviter des membres'
    }),
    noOptionsMessageText: intl.formatMessage({
        id: 'drawer.createGroup.multiSelect.noOptionsMessageText',
        defaultMessage: 'Pas de relations trouvés.'
    }),
    placeholder: intl.formatMessage({
        id: 'drawer.createGroup.multiSelect.placeholder',
        defaultMessage: 'Un de vos contacts'
    }),
    sendInvitations: intl.formatMessage({
        id: 'drawer.createGroup.multiSelect.sendInvitations',
        defaultMessage: 'Envoyer des invitations à'
    })
});

const AddContacts = ({ onClose = () => {}, onSubmit = () => {}, intl, initialValues }) => {
    const i18n = useMemo(() => formatMessages(intl), [intl]);

    return (
        <Drawer
            isOpen
            onClose={onClose}
            title={(
                <CategoryTitle
                    label={i18n.invitMembers}
                    icon={<Icon size="xl" iconName="Users" />}
                />
            )}
            placement="left"
        >
            <FinalForm onSubmit={onSubmit} initialValues={initialValues}>
                {({ handleSubmit, pristine, submitting, form }) => (
                    <Form onSubmit={handleSubmit} layout="vertical">
                        <Field
                            label={i18n.sendInvitations}
                            name="_members"
                            component={LabelUserMultiSelect}
                            notFoundContent={i18n.noOptionsMessageText}
                            placeholder={i18n.placeholder}
                        />
                        <ButtonActions>
                            <Button
                                iconName="Check"
                                onClick={form.submit}
                                color="primary"
                                isDisabled={pristine || submitting}
                                size="lg"
                            />
                        </ButtonActions>
                    </Form>
                )}
            </FinalForm>
        </Drawer>
    );
}

AddContacts.propTypes = {
    intl: PropTypes.any.isRequired,
    onSubmit: PropTypes.func,
    onClose: PropTypes.func,
};

export default injectIntl(AddContacts);
